const { forEach, clone } = require('lodash');
const DigitalPayPaymentErrorStateException = require('./digital-pay-payment-error-state.exception');
const DigitalPayPaymentErrorState = require('./digital-pay-payment-error-state');

/**
 * Maintains error states for DigitalPay payment instruments following an attempt at placing an order.
 */
class DigitalPayPaymentErrorStateService {
    constructor() {
        this._paymentErrorStates = [];
    }

    /**
     * Initialise Payment Error State
     */
    init() {
        this.clearErrors();
    }

    /**
     * Add a set of errors
     * @param {Array} errorState
     */
    addErrors(errorStates) {
        if (!errorStates || !errorStates.length) return;

        let validErrorStates = true;
        // Ensure given error states are valid.
        forEach(errorStates, (errorState) => {
            if (!(errorState instanceof DigitalPayPaymentErrorState)) {
                validErrorStates = false;
            }
        });

        if (!validErrorStates) {
            throw new DigitalPayPaymentErrorStateException('Invalid error state provided.');
        }

        // Return cloned errorStates to ensure onChange events are triggered.
        this._paymentErrorStates = clone(errorStates);
    }

    /**
     * Get all errors
     */
    getErrors() {
        // Clone to allow SimpleChange detection.
        return this._paymentErrorStates || [];
    }

    /**
     * Clear all errors
     */
    clearErrors() {
        this._paymentErrorStates = [];
    }
}

module.exports = DigitalPayPaymentErrorStateService;



// WEBPACK FOOTER //
// ./src/digitalpay/services/digital-pay-payment-error-state.service.js